import React from "react";
import * as dayjs from "dayjs";
import IntlMessages, { IntlGetText } from "util/IntlMessages";
import { Button } from "@material-ui/core";
import TableForm, { getTextLabels } from "components/Form/Table";
import CardBox from "components/CardBox/index";

const Table = ({
  data,
  handleOpenCRU,
  setCurrentRowObj,
  readOnly,
  handleOpenDel
}) => {
  const options = {
    filter: false,
    filterType: "dropdown",
    download: false,
    print: false,
    viewColumns: false,
    selectableRows: "none",
    search: false,
    textLabels: getTextLabels(),
  };

  const handleClick = (obj) => {
    handleOpenCRU();
    setCurrentRowObj(!obj ? null : obj);
  };

  const getRowObj = (tableMeta) => tableMeta.tableData[tableMeta.rowIndex];

  const columns = [
    {
      name: "startCycleDate",
      label: IntlGetText("cycleVials.startCycleDate"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) =>
          value ? dayjs(value).format("YYYY/MM/DD") : "",
      },
    },
    {
      name: "endCycleDate",
      label: IntlGetText("cycleVials.endCycleDate"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) =>
          value ? dayjs(value).format("YYYY/MM/DD") : "",
      },
    },
    {
      name: "adverseEvent",
      label: IntlGetText("cycleVials.adverseEvent"),
      options: { filter: false, sort: false },
    },
    {
      name: "vialsNumber",
      label: IntlGetText("cycleVials.vialsNumber"),
      options: { filter: false, sort: false },
    },
    {
      name: "lote",
      label: IntlGetText("cycleVials.lote"),
      options: { filter: false, sort: false },
    },
    {
      name: "expirationDate",
      label: IntlGetText("cycleVials.expirationDate"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) =>
          value ? dayjs(value).format("YYYY/MM/DD") : "",
      },
    },
    {
      name: "matricule",
      label: IntlGetText("cycleVials.matricule"),
      options: { filter: false, sort: false },
    },
    {
      name: "actions",
      label: <IntlMessages id="core.actions" />,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const rowObj = getRowObj(tableMeta);
          return (
            <>
              <Button
                onClick={() => handleClick(rowObj)}
                variant="contained"
                className="jr-btn jr-btn-xs"
                style={{ marginRight: "5px" }}
              >
                <i className="zmdi zmdi-edit"></i>
              </Button>
              {!readOnly && (
                <Button
                  onClick={() => {
                    setCurrentRowObj(rowObj);
                    handleOpenDel();
                  }}
                  variant="contained"
                  className="jr-btn jr-btn-xs"
                >
                  <i className="zmdi zmdi-delete"></i>
                </Button>
              )}
            </>
          );
        },
      },
    },
  ];

  return (
    <div className="row">
      <CardBox styleName="col-12" cardStyle="p-0 border-dialog-card">
        <TableForm
          className="border-dialog-card"
          data={data}
          columns={columns}
          options={options}
        />
      </CardBox>
      {!readOnly && (
        <div className="col-lg-12 col-md-12 col-xs-12 mt-4 text-center">
          <Button
            onClick={() => handleClick(null)}
            variant="contained"
            color="primary"
          >
            <IntlMessages id="core.add" />
          </Button>
        </div>
      )}
    </div>
  );
};

export default Table;
